const production = true;

/* VINFAST */
const appData = {
    appVersion: "v-1.2.0",
    appProduction: production,
    appDefaultArea: "JAWABARAT",
    appCompanyCode: "vinfast",
    appCompanyName: "AmartaVinfast",
    appCode: "VINFAST",
    appName: "Vinfast",
    appAbbreviation: "VIN",
}

export const appProduction = appData.appProduction;
export const appCompanyCode = appData.appCompanyCode;
export const appCompanyName = appData.appCompanyName;
export const appCode = appData.appCode;
export const appName = appData.appName;
export const appAbbreviation = appData.appAbbreviation;
export const appVersion = appData.appVersion;
export const appDefaultArea = appData.appDefaultArea;
